// Static data API for Cloudflare Pages deployment
// News-only: fetches from news-data.json

const BASE_URL = import.meta.env.VITE_DATA_URL || ''

// Cache control: manual refresh bypasses all caches
let _forceRefresh = false
export const forceRefreshNow = () => { _forceRefresh = true }
const fetchOpts = () => _forceRefresh ? { cache: 'no-store' } : {}
const cacheBuster = () => `?t=${Date.now()}`

// News data
export const fetchNews = async () => {
  const response = await fetch(`${BASE_URL}/news-data.json${cacheBuster()}`, fetchOpts())
  if (!response.ok) throw new Error('Failed to fetch news')
  return response.json()
}

// Markets data
export const fetchMarkets = async () => {
  const response = await fetch(`${BASE_URL}/markets-data.json${cacheBuster()}`, fetchOpts())
  if (!response.ok) throw new Error('Failed to fetch markets data')
  return response.json()
}

// Usage data
export const fetchUsage = async () => {
  const response = await fetch(`${BASE_URL}/usage-data.json${cacheBuster()}`, fetchOpts())
  if (!response.ok) throw new Error('Failed to fetch usage data')
  return response.json()
}

// Weather data (pre-generated, Chicago IL default)
export const fetchWeather = async () => {
  const response = await fetch(`${BASE_URL}/weather-data.json${cacheBuster()}`, fetchOpts())
  if (!response.ok) throw new Error('Failed to fetch weather')
  return response.json()
}

// Client-side weather fetch for geolocation override
export const fetchWeatherByCoords = async (lat, lon) => {
  const url = `https://api.open-meteo.com/v1/forecast`
    + `?latitude=${lat}&longitude=${lon}`
    + `&current=temperature_2m,relative_humidity_2m,apparent_temperature,weather_code,wind_speed_10m,wind_direction_10m`
    + `&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_probability_max`
    + `&temperature_unit=fahrenheit&wind_speed_unit=mph&precipitation_unit=inch`
    + `&timezone=auto&forecast_days=4`
  const response = await fetch(url)
  if (!response.ok) throw new Error('Failed to fetch weather by coords')
  return response.json()
}
